"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var handleOnKeyboardConfirm = function handleOnKeyboardConfirm(action) {
  return function (event) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      action(event);
    }
  };
};
var _default = exports["default"] = handleOnKeyboardConfirm;